<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-container v-if="!pending && reviews.length>0" class="flex gap-6 flex-col sm:flex-row">
    <!-- Left Side -->
    <div class="w-full md:w-2/5">
      <p class="text-xl">
        Reviews
      </p>
      <div>
        <v-rating
          v-if="rating"
          :model-value="rating"
          half-increments
          density="compact"
          readonly
          color="secondary"
        />
        <p>{{ reviews.length==1?'1 Rating':reviews.length + ' Ratings' }}</p>
        <!-- <p v-if="reviews.length=1">{{ reviews.length }} rating</p>
        <p v-else> 
          {{ reviews.length }} ratings
        </p> -->
      </div>
      <v-list
        class="bg-transparent"
        density="compact"
      >
        <v-list-item
          v-for="i in 5"
          :key="i"
        >
          <v-progress-linear
            :model-value="ratingPercentages[i]"
            class="ml-n1"
            height="15"
            rounded
          />

          <template #prepend>
            <span class="mr-2">{{ i }}</span>
            <!-- <v-icon 
              class="mx-3"
              icon="mdi-star"
            /> -->
          </template>

          <template #append>
            <div class="rating-values">
              <span class="ml-2"> {{ ratingCounts[i] }} </span>
            </div>
          </template>
        </v-list-item>
      </v-list>
      <Review
        v-if="reviewer"
        :id="useRoute().params.id"
        @review-submitted="getRatingStuff()"
      />
    </div>
    <!--Right Side-->
    <div class="w-full md:w-3/5">
      <!--Reviews Right Side-->
      <div
        v-if="reviews && reviews.length>0"
        class="gap-4 flex flex-col text-left w-full"
      >
        <div
          v-for="(review, idx) in reviews"
          :key="idx"
          class="bg-base-100 "
        >
          <div class="flex flex-wrap items-center <md:(flex-col gap-0)">
            <p class="font-bold text-xl w-full ">
              @{{ review.displayName }}
            </p>
            <v-rating
              :model-value="review.stars"
              half-increments
              density="compact"
              readonly
              color="secondary"
            />
          </div>
          <p class="">
            {{ review.msg }}
          </p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script setup>
import { collection, doc, getDoc, getAggregateFromServer } from 'firebase/firestore'
import { useCurrentUser, useCollection } from 'vuefire'
import { find, includes, reduce } from 'lodash-es'

const revRef = collection(useFirestore(),'products',useRoute().params.id,'reviews')
//Might need to replace this with paginated queries like the index
const reviews = ref()
const { pending } = useCollection(revRef, {ssrKey: "reviews:"+useRoute().params.id,target:reviews})

//this should be passed as props
// const productRef = doc(useFirestore(),'products',useRoute().params.id)
// const { data:product } = useDocument(productRef,{ssrKey:'product:'+useRoute().params.id})

const reviewer = ref(false)

const rating = ref(0)
const ratingCounts = ref({'1':0,'2':0,'3':0,'4':0,'5':0})
const ratingPercentages = ref({'1':0,'2':0,'3':0,'4':0,'5':0})

// watch(reviews,(r)=>{
//   if(r.length>0){
//     let count=0
//     let groups = {'1':0,'2':0,'3':0,'4':0,'5':0}
//     ratingCounts.value = reduce(r,(result,v)=>{
//       result[v.stars]+=1
//       count++
//       return result;
//     },groups)
//     for(let i=1;i<6;i++){
//       ratingPercentages.value[i] = (ratingCounts.value[i]/count)*100
//     }
//     console.log('Rating Percentages: ')
//     console.log(ratingPercentages.value)
//   } else{
//     console.log('Fuck')
//   }
// })

const getRatingStuff = () => {
  console.log("Getting rating stuff")
  let count=0
  let groups = {'1':0,'2':0,'3':0,'4':0,'5':0}
  ratingCounts.value = reduce(reviews.value,(result,v)=>{
    result[v.stars]+=1
    count++
    return result;
  },groups)
  for(let i=1;i<6;i++){
    ratingPercentages.value[i] = (ratingCounts.value[i]/count)*100
  }
}

//Wish this worked
// watch(reviews,()=>{
//   getRatingStuff()
// })

onMounted(async()=>{
  //might be able to replace this if we are processing all reviews locally to get counts anyway....
  try{
    let snap = await getAggregateFromServer(revRef, {averageStars: average('stars')})
    rating.value = snap.data().averageStars
    if(rating.value>0){
      getRatingStuff()
    }
  }catch{
    rating.value = 0
  }


  //determine if current user is a shopper, then let them review
  if(useCurrentUser().value){
    //look through the users orders collection for lineitems to toggle reviewer.value = true/false
    if(find(useUserDataStore().userData.orders,(o)=>{return find(o.lineItems,(l)=>{return l.id==useRoute().params.id})})!=undefined){
      reviewer.value = true
      //i really wish we were able to easily use firestore rules to check shoppers in products to authenticate updates...
    }
    //This is kinda what firestore rules is looking for (valid payment to be added to special shoppers collection)
    // let shopperRef = doc(useFirestore(),'products',useRoute().params.id,'shoppers',useCurrentUser().value.uid)
    // let shopperGet = await getDoc(shopperRef)
    // if(shopperGet.exists()){
    //   reviewer.value = true
    // }

    //This is probably what we want from the front-end
    //TODO
    //In the future we will likely only want this to run if a user attempts to leave a review (before displaying the popup), not onMounted
    // let userRef = doc(useFirestore(),'users',useCurrentUser().value.uid)
    // let userGet = await getDoc(userRef)
    // if(userGet.get('purchasedItems')?includes(userGet.get('purchasedItems'),useRoute().params.id):false){
    //   reviewer.value = true//but firestore won't let them unless they are found in the product's shoppers collection as well (so reviews will always be paid not necessarily delivered but most likely)
    // }
  }
})

// const shoppersRef = doc(useFirestore(),'products',useRoute().params.id,'shoppers',useCurrentUser().value.uid)
// const reviewer = ref((await getDoc(shoppersRef)).exists())

</script>